const searchInFields = (fieldsToSearch: string, searchTerm: string) => {
    const searchTermParts = searchTerm.split(' ');
    const normalizedFieldsToSearch = fieldsToSearch.replace(/[ \-.,_]/g, '');

    return searchTermParts.every(part => {
        const searchTermPart = part.trim().toLowerCase();
        return (
            normalizedFieldsToSearch.indexOf(searchTermPart) !== -1 ||
            fieldsToSearch.indexOf(searchTermPart) !== -1
        );
    });
};

export default searchInFields;
